import { useEffect, useState } from 'react';
import { ENUM_ECO_CART_EVENT, ItfEcoCart, ItfEcoCartItem } from './type.d';
import EcoCartStore from './ecoCartStore';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';

const ecoCartStore = EcoCartStore.getInstance();

export default function useEcoCart(): ItfEcoCart {
    const [cart, setCart] = useState<ItfEcoCart>(() => ecoCartStore.getCart());

    useEffect(() => {
        console.log('cart===', cart);
    }, [cart]);

    useEffect(() => {
        ecoCartStore.init();
        const unsubscribe = ecoCartStore.subscribe(setCart);
        return () => {
            unsubscribe();
        };
    }, []);

    return cart as ItfEcoCart;
}

// 也可以直接使用EcoDesignEventsBus.emit，仅留作备用
export const ecoCartActions = {
    open: (open: boolean) => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_OPEN, open);
    },
    add: (items: ItfEcoCartItem[]) => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, items);
    },
    increase: (item: ItfEcoCartItem) => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_INCREASE, item);
    },
    decrease: (item: ItfEcoCartItem) => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_DECREASE, item);
    },
    remove: (item: ItfEcoCartItem) => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_REMOVE, item);
    },
    getCart: () => ecoCartStore.getCart(),
};
